var locale = {
  placeholder: 'Zaman seç',
  rangePlaceholder: ['Başlangıç zamanı', 'Bitiş zamanı']
};
export default locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/time-picker/locale/tr_TR.js
// module id = 569
// module chunks = 1